import { initialFormState } from '../../../../store/redux/slices/form.slice';
import { FormState } from '../../../../store/types/form';
import { ImagesState } from '../../../../store/types/template';
import { NEW_ICON_BASE64, NEW_LOGO_BASE64 } from '../../../../utils/base64';

const BRANDING_FIELDS = [
  'backgroundColor',
  'componentFillColor',
  'componentFontColor',
  'buttonColor',
  'buttonCtaColor',
  'footerColor',
  'formLogoImage',
  'formFaviconImage',
] as const;

export const hasDefaultBranding = (form: FormState) =>
  BRANDING_FIELDS.every((field) => form[field] === initialFormState[field]);

export const templateLogo = (images: ImagesState): string | undefined =>
  (images.shared.logo !== NEW_LOGO_BASE64 ? images.shared.logo : '') ||
  images.apple.logo ||
  images.google.logo;

export const templateIcon = (images: ImagesState): string | undefined =>
  (images.shared.icon !== NEW_ICON_BASE64 ? images.shared.icon : '') ||
  images.apple.icon;
